import React from "react";
import styled from "styled-components";
import Header from "../components/Header";
import Layout from "../components/Layout";
import ninNikuImg from "../assets/images/nin-niku.jpg";
import yarigaiImg from "../assets/images/yarigai.jpg";
import tryImg from "../assets/images/try.jpg";

const ProductsContainer = styled.div``;

const Section = styled.section`
  padding: 5rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 2rem;
  text-align: center;
  color: #333;
`;

const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 4rem;
  margin-top: 3rem;
`;

const Product = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }

  &:nth-child(even) {
    direction: rtl;
  }

  &:nth-child(even) > div {
    direction: ltr;
  }

  @media (max-width: 768px) {
    overflow-x: hidden;
  }
`;

const ProductImage = styled.div`
  height: 300px;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 5rem;
  color: #0099cc;
  border-radius: 8px;
  overflow: hidden;
`;

const ProductContent = styled.div`
  h3 {
    font-size: 2rem;
    margin-bottom: 1rem;
    color: #333;
  }

  p {
    color: #666;
    margin-bottom: 1rem;
    line-height: 1.8;
  }

  ul {
    list-style: disc;
    margin-left: 1.5rem;
    margin-top: 1rem;
    color: #666;
    line-height: 1.8;
  }
`;

const Products = () => {
  return (
    <Layout>
      <ProductsContainer>
        <Header title="事業内容" subtitle="" showButton={false} />

        <Section>
          <SectionTitle data-aos="fade-up">私たちのサービス</SectionTitle>
          <ProductGrid>
            <Product data-aos="fade-right">
              <ProductImage style={{ backgroundColor: "#0c1e2f" }}>
                <img
                  src={yarigaiImg}
                  alt="システム開発"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              </ProductImage>
              <ProductContent>
                <h3>システム開発の受託・SES</h3>
                <p>
                  「やりがいドリブン　学びと挑戦が続く毎日へ。」を合言葉に、エンジニアが描く「こんな技術に触れてみたい」「こんな未来を創りたい」という想いを出発点に、最適なプロジェクトを一緒に探し、一緒に未来を考えるスタイルを大切にしています。
                </p>
                <p>
                  お客様には高度な技術力と豊富な経験を持つエンジニアによる受託開発とSESサービスを提供します。お客様のビジネス課題を深く理解し、最適なシステム開発を提案・実施します。
                </p>
              </ProductContent>
            </Product>

            <Product data-aos="fade-right">
              <ProductImage style={{ backgroundColor: "#0c1e2f" }}>
                <img
                  src={tryImg}
                  alt="IT教育"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              </ProductImage>
              <ProductContent>
                <h3>IT教育</h3>
                <p>
                  「ITスキルが、挑戦をもっと楽しくする」
                  を合言葉に、初心者向けにプログラミング教育事業を行っています。
                  0からWEBアプリケーションを作成しネットワーク上にデプロイするところまで全ての学習を提供しています。
                  講師の委託も可能です。
                </p>
              </ProductContent>
            </Product>

            <Product data-aos="fade-left">
              <ProductImage style={{ backgroundColor: "#c78543" }}>
                <img
                  src={ninNikuImg}
                  alt="農業"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </ProductImage>
              <ProductContent>
                <h3>農業</h3>
                <p>
                  無農薬ニンニク、無農薬玉ねぎをメインに多品目を栽培。
                  環境負荷を抑え、日本が元気になるような美味しい野菜をサステナブルな農業で挑戦しています。
                </p>
              </ProductContent>
            </Product>
          </ProductGrid>
        </Section>
      </ProductsContainer>
    </Layout>
  );
};

export default Products;
